/**
 * Web-local helper for unwrapping canonical contact values.
 *
 * Contacts from the objects API surface emails/phones in the canonical
 * `{ value: string }[]` shape, but older/manual callers still pass plain strings,
 * so consumers must tolerate both. Rendering the raw `{ value }` object as a React
 * child throws "Objects are not valid as a React child" (#4906), so every read
 * site must unwrap to a string first.
 *
 * Unwraps ONE element (string or `{ value }`) to a string, not an array — distinct
 * from @xavior/domain's `contactEmailValues` (array → `string[]`). Kept web-local
 * because apps/web must not import @xavior/domain (package-boundary).
 */

/** Extract a plain string from a canonical contact element (string or `{ value }` object). */
export function extractContactValue(v: unknown): string {
  if (typeof v === 'string') return v;
  if (v && typeof v === 'object' && typeof (v as { value?: unknown }).value === 'string') {
    return (v as { value: string }).value;
  }
  return '';
}
